import * as actionTypes from './actionTypes'

import mathTestApi from './../../api/mathTest';

const mathTestRequest = () => ({
  type: actionTypes.MATH_TEST_REQUEST
});

const mathTestReceive = data => ({
  type: actionTypes.MATH_TEST_RECEIVE,
  data,
});

const mathTestError = error => ({
  type: actionTypes.MATH_TEST_ERROR,
  error,
});

const mathTestFetch = () => dispatch => {
  dispatch(mathTestRequest());
  return mathTestApi.getMathTest().then(data => dispatch(mathTestReceive(data))).catch(error => dispatch(mathTestError(error)));
};

const mathTestShouldFetch = state => {
  const tasksState = state;
  if (tasksState.isFetching) {
    return true;
  }
  if (!tasksState.data) {
    return false;
  }
  return tasksState.didInvalidate;
};

export const mathTestFetchIfNeeded = () => (dispatch, getState) => {
  if (!mathTestShouldFetch(getState().tasks)) {
    return Promise.resolve();
  }
  return dispatch(mathTestFetch());
};

export const mathTestSet = data => (dispatch) => {
  dispatch(mathTestRequest());
  return mathTestApi.nextStep(data).then(data => dispatch(mathTestReceive(data))).catch(error => dispatch(mathTestError(error)));
};



// WEBPACK FOOTER //
// ./src/store/mathTest/actions.js